module.exports = __webpack_public_path__ + "img/WebCrawlerCompaines.0adf236b.svg";